import React from 'react';
import classNames from 'classnames';
import TransitionGroup from 'react-transition-group/TransitionGroup';
import Transition from 'react-transition-group/CSSTransition';
import {SVGIcon} from '@homeaway/react-svg';
import {ARROW_LEFT__24} from '@homeaway/svg-defs';

import {FlagsMenu} from './flags-menu/FlagsMenu';
import {HelpMenu} from './help-menu/HelpMenu';
import {TrayMenu} from './tray-menu/TrayMenu';

import './Tray.less';

export class Tray extends React.Component {
    state = {
        activeMenu: 'tray',
    };

    componentDidUpdate(prevProps) {
        if (this.props.isOpen === false && this.props.isOpen !== prevProps.isOpen) {
            setTimeout(/* istanbul ignore next */() => this.setActiveMenu('tray'), 300);
        }
    }

    x = null;

    transitionProps = {
        backdrop: {
            classNames: {
                enter: 'site-header-tray__backdrop--enter',
                enterActive: 'site-header-tray__backdrop--enter-active',
                exit: 'site-header-tray__backdrop--exit',
                exitActive: 'site-header-tray__backdrop--exit-active',
            },
            timeout: 700,
        },
        menu: {
            classNames: {
                enter: 'site-header-tray__menu--enter',
                enterActive: 'site-header-tray__menu--enter-active',
                exit: 'site-header-tray__menu--exit',
                exitActive: 'site-header-tray__menu--exit-active',
            },
            timeout: 700,
        },
        drawer: {
            classNames: {
                enter: 'site-header-tray__drawer--enter',
                enterActive: 'site-header-tray__drawer--enter-active',
                exit: 'site-header-tray__drawer--exit',
                exitActive: 'site-header-tray__drawer--exit-active',
            },
            timeout: 700,
        },
        avatar: {
            classNames: {
                enter: 'site-header-tray__menu-avatar--enter',
                enterActive: 'site-header-tray__menu-avatar--enter-active',
                exit: 'site-header-tray__menu-avatar--exit',
                exitActive: 'site-header-tray__menu-avatar--exit-active',
            },
            timeout: 700
        },
        back: {
            classNames: {
                enter: 'site-header-tray__menu-back--enter',
                enterActive: 'site-header-tray__menu-back--enter-active',
                exit: 'site-header-tray__menu-back--exit',
                exitActive: 'site-header-tray__menu-back--exit-active',
            },
            timeout: 700
        }
    };

    get className() {
        return classNames(
            'site-header-tray',
            {'site-header-tray--open': this.props.isOpen},
        );
    }

    get feedbackComponent() {
        if (!this.props.isMobile) {
            return null;
        }

        return this.props.feedbackComponent;
    }

    handleClickBack = () => {
        this.setActiveMenu('tray');
    }

    handleClickBackdrop = () => {
        this.props.handleToggleOpen();
    }

    setActiveMenu = (menu = 'tray') => {
        this.setState({
            activeMenu: menu,
        });
    }

    handleTouchStart = (e) => {
        const clientX = e.changedTouches[0].clientX;

        if (clientX && !this.x) {
            this.x = clientX;
        }
    }

    handleTouchEnd = (e) => {
        const clientX = e.changedTouches[0].clientX;
        if (clientX && this.x - clientX < -100) {
            if (this.state.activeMenu === 'tray') {
                this.props.handleToggleOpen();
            } else {
                this.setActiveMenu('tray');
            }
        }
        this.x = null;
    }



    // eslint-disable-next-line complexity
    render() {
        return (
            <div className={this.className} onTouchEnd={this.handleTouchEnd} onTouchStart={this.handleTouchStart}>
                <TransitionGroup component="div" key="header-backdrop">
                    {this.props.isOpen && (
                        <Transition {...this.transitionProps.backdrop}>
                            <div
                                className="site-header-tray__backdrop"
                                onClick={this.handleClickBackdrop}
                                onKeyPress={this.handleClickBackdrop}
                                role="none"
                            />
                        </Transition>
                    )}
                </TransitionGroup>
                <div className="site-header-tray__container">
                    <div className="site-header-tray__container-header">
                        {!this.props.traveler && this.props.login && (
                            <div className="site-header-tray__header">
                                <TransitionGroup className="site-header-tray__header--wrapper" component="div" key="header-mobile-header">
                                    {this.state.activeMenu !== 'tray' &&
                                        <Transition {...this.transitionProps.back}>
                                            <div className="site-header-tray__menu-back"
                                                onClick={this.handleClickBack}
                                                onKeyPress={this.handleClickBack}
                                                role="button"
                                                tabIndex={0}
                                            >
                                                <SVGIcon inlineFlex markup={ARROW_LEFT__24}/>
                                            </div>
                                        </Transition>
                                    }
                                </TransitionGroup>
                            </div>
                        )}
                        {this.props.traveler && (
                            <div className="site-header-tray__header site-header-tray__header--traveler">

                                <TransitionGroup className="site-header-tray__header--wrapper" component="div" key="header-mobile-header">
                                    {this.state.activeMenu !== 'tray' &&
                                        <Transition {...this.transitionProps.back}>
                                            <div className="site-header-tray__menu-back"
                                                onClick={this.handleClickBack}
                                                onKeyPress={this.handleClickBack}
                                                role="button"
                                                tabIndex={0}
                                            >
                                                <SVGIcon inlineFlex markup={ARROW_LEFT__24}/>
                                            </div>
                                        </Transition>
                                    }

                                    {this.state.activeMenu === 'tray' &&
                                        <Transition {...this.transitionProps.avatar}>
                                            <div className="site-header-tray__menu-avatar">
                                                <img
                                                    alt="avatar"
                                                    aria-hidden="true"
                                                    className="site-header-tray__header-avatar img-circle"
                                                    role="presentation"
                                                    src={this.props.traveler.avatar.image}
                                                />
                                                {this.props.traveler && this.props.traveler.items && this.props.traveler.items.filter((item) => item.cssClass === 'se-traveler-profile').map((item, index) => {
                                                    // FIXME: This is a hack to identify the inbox item
                                                    // TODO: Sort out a maintainable way to indentify and handle inbox and inbox data
                                                    return (
                                                        <a className="site-header-tray__menu-item-link" data-bypass="true" href={item.link} key={item.link || index}>
                                                            <span className="site-header-tray__header-greeting">
                                                                {this.props.traveler.label}
                                                            </span>
                                                        </a>
                                                    );
                                                })}
                                            </div>
                                        </Transition>
                                    }
                                </TransitionGroup>
                            </div>
                        )}
                    </div>
                    <TransitionGroup className="site-header-tray__container__items" component="div" key="header-mobile-container">
                        {this.state.activeMenu === 'tray' && (
                            <Transition {...this.transitionProps.menu}>
                                <TrayMenu
                                    countryCode={this.props.countryCode}
                                    currencyCode={this.props.currencyCode}
                                    extraNav={this.props.extraNav}
                                    feedbackComponent={this.feedbackComponent}
                                    flags={this.props.flags}
                                    globalizationSelector={this.props.globalizationSelector}
                                    handleTravelerLogin={this.handleClickBackdrop}
                                    help={this.props.help}
                                    inbox={this.props.inbox}
                                    isOpen={this.props.isOpen}
                                    languageCode={this.props.languageCode}
                                    login={this.props.login}
                                    lyp={this.props.lyp}
                                    onGlobalSelectorChange={this.props.onGlobalSelectorChange}
                                    renderCountryLanguageSelector={this.props.renderCountryLanguageSelector}
                                    renderCurrencySelector={this.props.renderCurrencySelector}
                                    scratchpad={this.props.scratchpad}
                                    setActiveMenu={this.setActiveMenu}
                                    traveler={this.props.traveler}
                                />
                            </Transition>
                        )}

                        {this.state.activeMenu === 'flag' && (
                            <Transition {...this.transitionProps.drawer}>
                                <FlagsMenu
                                    flags={this.props.flags}
                                    setActiveMenu={this.setActiveMenu}
                                />
                            </Transition>
                        )}

                        {this.state.activeMenu === 'help' && (
                            <Transition {...this.transitionProps.drawer}>
                                <HelpMenu
                                    help={this.props.help}
                                    setActiveMenu={this.setActiveMenu}
                                />
                            </Transition>
                        )}
                    </TransitionGroup>
                </div>
            </div>
        );
    }
}
